import { render, staticRenderFns } from "./hostProfile.vue?vue&type=template&id=486d58a2&scoped=true"
import script from "./hostProfile.vue?vue&type=script&lang=js"
export * from "./hostProfile.vue?vue&type=script&lang=js"
import style0 from "./hostProfile.vue?vue&type=style&index=0&id=486d58a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d58a2",
  null
  
)

export default component.exports